import { render, staticRenderFns } from "./AddCurriculamMaterial.vue?vue&type=template&id=32fec40c&scoped=true"
import script from "./AddCurriculamMaterial.vue?vue&type=script&lang=js"
export * from "./AddCurriculamMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fec40c",
  null
  
)

export default component.exports